var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex-container-column"},[_c('button',{staticClass:"btn btn-primary--outlined btn--flat",on:{"click":_vm.back}},[_c('i',{staticClass:"far fa-arrow-alt-circle-left"}),_c('span',[_vm._v("Voltar")])]),_c('p',[_vm._v("Desculpe, você não tem acesso a esta página.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }